module.exports = __webpack_public_path__ + "static/profilepic_logan-0270018f71436cf0b259302f698d7fa5.png";